<template>
  <validacao-selo v-if="selo" /><painel v-else :validacao="true" />
</template>
<script>
import { atualUfDefinition } from "@/helpers/utils";
import Painel from "./Painel.vue";
import ValidacaoSelo from "./ValidacaoSelo.vue";
import { usarValidacaoSelo } from "../services/validacaoRollout";
export default {
  components: { Painel, ValidacaoSelo },
  computed: {
    selo() {
      return usarValidacaoSelo(atualUfDefinition);
    },
  },
};
</script>
